import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
	getAllRole() {
		return request({
			url: store.getters.getPostUrl + 'mes/role/all',
			method: 'get'
		})
	},
	getUserList(param) {
		return request({
			url: store.getters.getPostUrl + '/user',
			method: 'get',
			params: param
		})
	},
	getTimeList(param) {
		return request({
			url: store.getters.getPostUrl + '/time/page',
			method: 'get',
			params: param
		})
	},
	getAllUser(param) {
		return request({
			url: store.getters.getPostUrl + '/user/list',
			method: 'get',
			data: param
		})
	},
	resetPassword(param) {
		return request({
			url: store.getters.getPostUrl + '/user/list/' + param,
			method: 'get',
		})
	},
	addArea(data) {
		return request({
			url: store.getters.getPostUrl + '/area/add',
			method: 'post',
			data: data
		})
	},
	addUser(data) {
		return request({
			url: store.getters.getPostUrl + '/role/add',
			method: 'post',
			data: data
		})
	},
	addTime(data) {
		return request({
			url: store.getters.getPostUrl + '/time/add',
			method: 'post',
			params: data
		})
	},
	updataTime(data) {
		return request({
			url: store.getters.getPostUrl + '/time/update',
			method: 'put',
			params: data
		})
	},
	addNewUser(data) {
		return request({
			url: store.getters.getPostUrl + '/user',
			method: 'post',
			data: data
		})
	},
	updataNewUser(data, id) {
		return request({
			url: store.getters.getPostUrl + '/user/' + id,
			method: 'put',
			data: data
		})
	},
	addEquipment(data) {
		return request({
			url: store.getters.getPostUrl + '/device/add',
			method: 'post',
			data: data
		})
	},
	updataArea(data) {
		return request({
			url: store.getters.getPostUrl + '/area/update',
			method: 'put',
			data: data
		})
	},
	updataEquipment(data) {
		return request({
			url: store.getters.getPostUrl + '/device/update',
			method: 'put',
			data: data
		})
	},
	updataUser(data) {
		return request({
			url: store.getters.getPostUrl + '/role/update',
			method: 'put',
			data: data
		})
	},
	reset(id) {
		return request({
			url: store.getters.getPostUrl + '/cmm/user/password/' + id,
			method: 'get'
		})
	},
	delEquipment(id) {
		return request({
			url: store.getters.getPostUrl + '/device/delete',
			method: 'delete',
			data: id
		})
	},
	delArea(id) {
		return request({
			url: store.getters.getPostUrl + '/Area/delete',
			method: 'delete',
			data: id
		})
	},
	delTime(id) {
		return request({
			url: store.getters.getPostUrl + '/time/delete',
			method: 'delete',
			data: id
		})
	},
	delUser(id) {
		return request({
			url: store.getters.getPostUrl + '/role/delete',
			method: 'delete',
			data: id
		})
	},
	delNewUser(id) {
		return request({
			url: store.getters.getPostUrl + '/user',
			method: 'delete',
			data: id
		})
	},
	delCustomer(id) {
		return request({
			url: store.getters.getPostUrl + '/customer/delete',
			method: 'delete',
			data: id
		})
	},
	AddCustomer(data) {
		return request({
			url: store.getters.getPostUrl + '/customer/add',
			method: 'post',
			data: data
		})
	},

	UpdateCustomer(data) {
		return request({
			url: store.getters.getPostUrl + '/customer/update',
			method: 'put',
			data: data
		})
	},
	getAreaMesList(data) {
		return request({
			url: store.getters.getPostUrl + '/area/page',
			method: 'get',
			params: data
		})
	},
	getUserName(data) {
		return request({
			url: store.getters.getPostUrl + '/user/getUserByName',
			method: 'post',
			data: data
		})
	},
	getCustomerList(data) {
		return request({
			url: store.getters.getPostUrl + '/customer/page',
			method: 'get',
			params: data
		})
	},
	getRoleList1() {
		return request({
			url: store.getters.getPostUrl + '/role/list',
			method: 'get',
		})
	},
	getRoleList(data) {
		return request({
			url: store.getters.getPostUrl + '/role/page',
			method: 'get',
			params: data
		})
	},
	getAdressList(data) {
		return request({
			url: store.getters.getPostUrl + '/area/list',
			method: 'get',
			params: data
		})
	},
	getDictionaryList(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictName',
			method: 'get',
			params: data
		})
	},
	getDictionaryMes(data, id) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictContent/' + id,
			method: 'get',
			params: data
		})
	},
	AddDictionary(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictName',
			method: 'post',
			data: data
		})
	},
	AddDictionaryMes(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictContent',
			method: 'post',
			data: data
		})
	},
	UpdateDictionaryMes(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictContent',
			method: 'put',
			data: data
		})
	},
	UpdateDictionary(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictName',
			method: 'put',
			data: data
		})
	},
	deleteDictionary(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictName',
			method: 'delete',
			data: data
		})
	},
	deleteDictionaryMes(data) {
		return request({
			url: store.getters.getPostUrl + '/business/dict/dictContent',
			method: 'delete',
			data: data
		})
	},
	getDeviceList(data) {
		return request({
			url: store.getters.getPostUrl + '/device/page',
			method: 'get',
			params: data
		})
	},
	getDeviceType() {
		return request({
			url: store.getters.getPostUrl + '/device/getDeviceType',
			method: 'get',
			params: ''
		})
	},
	getMenusByRoleLevel(data) {
		return request({
			url: store.getters.getPostUrl + '/role/getMenusByRoleLevel',
			method: 'get',
			params: data
		})
	},
	getContomerAllList() {
		return request({
			url: store.getters.getPostUrl + '/customer/getContomerList',
			method: 'get',
		})
	},
	getChooseCustomerList(data) {
		return request({
			url: store.getters.getPostUrl + '/customer/getChooseCustomerList',
			method: 'post',
			data: data
		})
	},

	updateUserCustomerRelation(data) {
		return request({
			url: store.getters.getPostUrl + '/customer/updateUserCustomerRelation',
			method: 'post',
			data: data
		})
	},

	AddUserArea(data) {
		return request({
			url: store.getters.getPostUrl + '/userArea/add',
			method: 'post',
			data: data
		})
	},

	//
	selectUserList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/page',
			method: 'post',
			data: param
		})
	},
	insert(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user',
			method: 'post',
			data: param
		})
	},
	update(id, param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/' + id,
			method: 'put',
			data: param
		})
	},
	del(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user',
			method: 'delete',
			data: param
		})
	},
	selectRoleList() {
		return request({
			url: store.getters.getPostUrl + 'mes/role/all',
			method: 'get'
		})
	},
	selectAllUserList(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/all',
			method: 'post',
			data: param
		})
	},
	resetPassword(id) {
		return request({
			url: store.getters.getPostUrl + '/mes/user/password/' + id,
			method: 'get'
		})
	},
	getByName(param) {
		return request({
			url: store.getters.getPostUrl + '/mes/user/byName',
			method: 'get',
			params: param
		})
	},
	getByOrganization(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/byOrganization',
			method: 'post',
			data: param
		})
	},
	remove(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/delete',
			method: 'delete',
			params: param
		})
	},
	updateState(param) {
		return request({
			url: store.getters.getPostUrl + 'mes/user/updateState',
			method: 'put',
			params: param
		})
	},
	test(param) {
		return request({
			url: store.getters.getPostUrl + 'organization/test',
			method: 'get',
			params: param,
		})
	},

}



// WEBPACK FOOTER //
// ./src/assets/js/system/user.js